<template>
  <div class="col-12">
    <div class="search-padd">
      <div class="scraping_header"></div>
      <div style="clear: both;" class="margin-bottom-10"></div>
      <div class="row pt-2">
      <div class="col-2 hidden">
        <div class="list-group" id="list-tab" role="tablist">

        </div>
      </div>




          <div class="col-12 pl-0">
            <div class="tab-content" id="nav-tabContent">
              <component 
              :is="selectedComponent" 
              :ref="selectedComponent" 
              :pathwayId=pathwayId
              :accountId=accountId
              isPathwayTab=true>
              </component>
            </div>                
          </div>

        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import EventBus from '../../bus';
import { store } from '../../store/store';
import { Validator } from "vee-validate";
import moment from 'moment';
import PathwaysTab from './enterprise_lookup_pathway_list_tab.vue';
import PathwayShowTab from './enterprise_lookup_showpathway.vue';
import PathwayStepTab from './enterprise_lookup_pathway_step.vue';


Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

const today = new Date();
today.setHours(0, 0, 0, 0);

export default {
      props: ['accountId'],
      data() {
        return {
          selectedComponent: 'PathwaysTab',
          pathwayId: '',
        }
      },
      components: {
        PathwaysTab,
        PathwayStepTab,
        PathwayShowTab,
      },
      methods: {
        selectPathwayStepTab(pathwayId) {
          this.pathwayId = pathwayId;
          this.selectedComponent = 'PathwayStepTab';
        },
        showPathwayStepTab(pathwayId) {
          this.pathwayId = pathwayId;
          this.selectedComponent = 'PathwayShowTab';
        },
      },
      mounted() {
        EventBus.$on('VeeValidate', () => {
          this.$validator.validateAll();
        });
      },
      created() {
        setTimeout(() => {
          if(this.accountId > 0) {
            if((store.state.active_tab)) {
              this.selectedComponent = store.state.active_sub_tab;
              let page_url = '';
              let active_tab = '';
              let active_sub_tab = '';
              store.dispatch('active_tab', { page_url, active_tab, active_sub_tab })
            }
          }
        }, 500);

      }
}
</script>

<style scoped>
#list-tab a {
  margin-bottom: 5px;
  border-radius: 3px;
  padding: 4px 8px;
  border-color: #00ACEE;
  border-width: 1px;
  color: #000000;
  border-radius: 5px;
  cursor: pointer;
}

#list-tab a:active,
.list-group-item.active {
  background-color: #00ACEE;
  color: #FFFFFF !important;
}
.pathways_step {
  font-size: 13px;
}
.pathway_objectives_box .d-flex div {
  width: 85px;
  margin-bottom: 15px;
  cursor: pointer;
}
.pathway_objective_focus {
  color: #00ACEE !important;
  background-color: #f0f9fc !important;
  border-color: #6cc2e2 !important;
  border: 1px solid #6cc2e2 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/enterprise_lookup_pathway_tab.vue